import { useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";

const styles = {
  page:       { minHeight: "100vh", background: "#0f172a", color: "#e2e8f0", padding: "40px 24px", fontFamily: "Inter, sans-serif" },
  card:       { maxWidth: 600, margin: "0 auto", background: "#1e293b", borderRadius: 12, padding: 40, border: "1px solid #334155" },
  title:      { fontSize: 24, fontWeight: 700, color: "#f1f5f9", marginBottom: 8 },
  subtitle:   { fontSize: 14, color: "#94a3b8", marginBottom: 32 },
  label:      { display: "block", fontSize: 13, fontWeight: 600, color: "#94a3b8", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" },
  input:      { width: "100%", background: "#0f172a", border: "1px solid #334155", borderRadius: 8, padding: "10px 14px", color: "#f1f5f9", fontSize: 14, marginBottom: 24, boxSizing: "border-box" },
  textarea:   { width: "100%", background: "#0f172a", border: "1px solid #334155", borderRadius: 8, padding: "10px 14px", color: "#f1f5f9", fontSize: 14, marginBottom: 24, boxSizing: "border-box", minHeight: 140, resize: "vertical" },
  typeRow:    { display: "flex", gap: 12, marginBottom: 24 },
  typeBtn:    (active, color) => ({ flex: 1, padding: "10px 0", borderRadius: 8, border: `2px solid ${active ? color : "#334155"}`, background: active ? `${color}22` : "transparent", color: active ? color : "#94a3b8", fontWeight: 600, fontSize: 14, cursor: "pointer" }),
  submitBtn:  (disabled) => ({ width: "100%", padding: "12px 0", borderRadius: 8, background: disabled ? "#334155" : "#3b82f6", color: disabled ? "#64748b" : "#fff", fontWeight: 700, fontSize: 15, border: "none", cursor: disabled ? "not-allowed" : "pointer" }),
  success:    { background: "#052e16", border: "1px solid #16a34a", borderRadius: 8, padding: 20, marginTop: 24, color: "#4ade80" },
  error:      { background: "#2d0a0a", border: "1px solid #ef4444", borderRadius: 8, padding: 16, marginTop: 16, color: "#f87171", fontSize: 14 },
};

export default function FeedbackForm() {
  const [type,        setType]        = useState("bug");
  const [title,       setTitle]       = useState("");
  const [description, setDescription] = useState("");
  const [submitting,  setSubmitting]  = useState(false);
  const [result,      setResult]      = useState(null);
  const [error,       setError]       = useState(null);

  const handleSubmit = async () => {
    setError(null);
    setSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE}/api/feedback`, {
        method:  "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body:    JSON.stringify({ type, title, description }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Submission failed");
      setResult(data);
      setTitle("");
      setDescription("");
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const disabled = submitting || title.trim().length < 5 || description.trim().length < 10;

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.title}>Submit Feedback</div>
        <div style={styles.subtitle}>Report a bug or request a feature. Your submission goes directly to our development team.</div>

        <label style={styles.label}>Type</label>
        <div style={styles.typeRow}>
          <button style={styles.typeBtn(type === "bug", "#ef4444")}     onClick={() => setType("bug")}>🐛 Bug Report</button>
          <button style={styles.typeBtn(type === "feature", "#3b82f6")} onClick={() => setType("feature")}>✨ Feature Request</button>
        </div>

        <label style={styles.label}>Title</label>
        <input
          style={styles.input}
          placeholder={type === "bug" ? "e.g. Risk score not updating after assessment" : "e.g. Export assessment results to PDF"}
          value={title}
          onChange={e => setTitle(e.target.value)}
        />

        <label style={styles.label}>Description</label>
        <textarea
          style={styles.textarea}
          placeholder={type === "bug" ? "Steps to reproduce, what you expected, what happened instead..." : "Describe the feature and why it would be valuable..."}
          value={description}
          onChange={e => setDescription(e.target.value)}
        />

        <button style={styles.submitBtn(disabled)} onClick={handleSubmit} disabled={disabled}>
          {submitting ? "Submitting..." : "Submit Feedback"}
        </button>

        {error && <div style={styles.error}>{error}</div>}

        {result && (
          <div style={styles.success}>
            ✅ Feedback submitted — Issue #{result.issue_number} created. Thank you!
          </div>
        )}
      </div>
    </div>
  );
}
